import { RcFile } from 'antd/lib/upload'
import { Dispatch } from 'redux'
import {
  FetchUploadSalaryCardExcelFailureAction,
  FetchUploadSalaryCardExcelRequestAction,
  FetchUploadSalaryCardExcelResetAction,
  FetchUploadSalaryCardExcelSuccessAction,
  SalaryCardActions,
  SalaryCardActionTypes,
  SalaryCardListExcelType,
} from 'store/types/salaryCard'
import { read, utils } from 'xlsx'
import { setGlobalErrorAction } from '../globalError'
import { GlobalErrorActions } from 'store/types/globalError'
import IMask from 'imask/holder'
import { t } from 'i18next'

function extractCode(input: string) {
  const sanitizedInput = input.replace(/[^a-zA-Z0-9]/g, '')
  const match = sanitizedInput.match(/DE\d+/)
  return match ? match[0] : null
}

function maskedValue(value: any, maskOptions: any) {
  const mask = IMask.createMask(maskOptions)
  mask.resolve(String(value))
  return mask.value
}

const convertBase64 = async (
  file: RcFile
): Promise<SalaryCardListExcelType[]> => {
  return new Promise((resolve, reject) => {
    const fileReaderCheck = new FileReader()
    fileReaderCheck.readAsText(file)

    fileReaderCheck.onload = () => {
      if (fileReaderCheck.result.trim().startsWith('<!doctype html>')) {
        return reject('Fayl formatı düzgün deyil.')
      }

      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)
      fileReader.onload = () => {
        const bufferArray = fileReader.result

        const wb = read(bufferArray, { type: 'array' })
        const brkdField = wb.Workbook?.Names?.find(
          (name) => name.Name === 'BRKD'
        )

        if (
          !wb.SheetNames.includes('HidSh') ||
          !brkdField ||
          wb.Sheets.HidSh[extractCode(brkdField.Ref)]?.v !== 'q1'
        ) {
          reject(t('orders.salaryCardOrder.restrictionTexts.templateError1'))
        }

        if (!wb.SheetNames.includes('No_rename')) {
          reject(t('orders.salaryCardOrder.restrictionTexts.templateError2'))
        }

        const data = utils.sheet_to_json(wb.Sheets.No_rename)
        const indexes: { [key: string]: string } = {
          __EMPTY_1: 'id', // ids
          __EMPTY_2: 'customerInfo',
          __EMPTY_3: 'serialType',
          __EMPTY_4: 'serialNo',
          __EMPTY_5: 'pin',
          __EMPTY_6: 'position',
          __EMPTY_7: 'salary',
          __EMPTY_8: 'phoneNumber',
          __EMPTY_9: 'email',
        }

        const filterData = data.filter((d) => {
          const cellCheck =
            Object.keys(indexes).filter(
              (i) => d[i] !== undefined && d[i] !== ''
            ).length !== 0
          return cellCheck && d.__rowNum__ > 3
        })

        const excelData = filterData.map((item: any) => {
          const transformedItem: { [key: string]: any } = {}

          Object.keys(indexes).forEach((key) => {
            if (indexes[key] === 'id') {
              transformedItem[indexes[key]] = item[key] - 1
            } else if (indexes[key] === 'pin') {
              transformedItem[indexes[key]] = maskedValue(item[key] ?? '', {
                mask: /^[A-Za-z0-9]{0,7}$/,
                prepare: (str) => str.toUpperCase(),
              })
            } else if (indexes[key] === 'code') {
              transformedItem[indexes[key]] = maskedValue(item[key] ?? '', {
                mask: /^[A-Za-z0-9]{0,30}$/,
                maxLength: 30, 
                prepare: (str) => str.toUpperCase()
              })
            } 
            else if (indexes[key] === 'salary') {
              transformedItem[indexes[key]] = maskedValue(item[key], {
                mask: Number,
                signed: false, 
                thousandsSeparator: ' ', 
                scale: 0, 
                min: 0
              })
            } 
            else {
              transformedItem[indexes[key]] = item[key] ?? ''
            }
          })
          return transformedItem
        })

        resolve(excelData)
      }
    }
  })
}

export const fetchUploadSalaryCardExcelRequest =
  (): FetchUploadSalaryCardExcelRequestAction => ({
    type: SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_REQUEST,
  })

export const resetSalaryExcel = (): FetchUploadSalaryCardExcelResetAction => ({
  type: SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_RESET,
})

export const fetchUploadSalaryCardExcelSuccess = (
  salaryCardList: SalaryCardListExcelType[]
): FetchUploadSalaryCardExcelSuccessAction => ({
  type: SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_SUCCESS,
  payload: salaryCardList,
})

export const fetchUploadSalaryCardExcelFailure = (
  error
): FetchUploadSalaryCardExcelFailureAction => ({
  type: SalaryCardActionTypes.FETCH_UPLOAD_SALARY_CARD_EXCEL_FAILURE,
  payload: error,
})

export const fetchEmployeeInfo = (file: RcFile) => {
  return async (dispatch: Dispatch<SalaryCardActions | GlobalErrorActions>) => {
    dispatch(fetchUploadSalaryCardExcelRequest())

    try {
      const data = await convertBase64(file)
      dispatch(fetchUploadSalaryCardExcelSuccess(data))
    } catch (error) {
      dispatch(fetchUploadSalaryCardExcelFailure(error))
      dispatch(setGlobalErrorAction(error ?? ''))
    }
  }
}
